<template>
  <BusinessCrud
    title="优惠券"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getCouponList"
    :save-api="saveCoupon"
    :delete-api="deleteCoupon"
    :defaults="{ couponType: '满减券', receiveMode: '主动领取', thresholdAmount: 0, discountAmount: 0, validDays: 0, totalCount: 0, receiveCount: 0, usedCount: 0, status: 1 }"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getCouponList, saveCoupon, deleteCoupon } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    return {
      getCouponList,
      saveCoupon,
      deleteCoupon,
      searchFields: [
        { key: 'name', label: '优惠券名称' },
        { key: 'receiveMode', label: '发放方式', type: 'select', options: [{ label: '主动发放', value: '自动发放' }, { label: '用户领取', value: '主动领取' }] },
        { key: 'status', label: '状态', type: 'select', options: [{ label: '启用', value: 1 }, { label: '停用', value: 0 }] }
      ],
      columns: [
        { title: '名称', dataIndex: 'name' },
        { title: '类型', dataIndex: 'couponType' },
        { title: '发放方式', dataIndex: 'receiveMode', customRender: value => value === '自动发放' || value === '主动发放' ? '主动发放' : '用户领取' },
        { title: '发放对象', dataIndex: 'grantTarget' },
        { title: '门槛', dataIndex: 'thresholdAmount' },
        { title: '优惠金额', dataIndex: 'discountAmount' },
        { title: '发行量', dataIndex: 'totalCount', customRender: (value, record) => record.receiveMode === '主动领取' ? value : '不限数量' },
        { title: '领取量', dataIndex: 'receiveCount' },
        { title: '使用量', dataIndex: 'usedCount' },
        { title: '开始时间', dataIndex: 'startTime' },
        { title: '结束时间', dataIndex: 'endTime' },
        { title: '领取后有效', dataIndex: 'validDays', customRender: value => Number(value) > 0 ? `${value}天` : '按结束时间' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } }
      ],
      formFields: [
        { key: 'name', label: '优惠券名称' },
        { key: 'couponType', label: '优惠券类型', type: 'select', options: [{ label: '满减券', value: '满减券' }, { label: '包邮券', value: '包邮券' }] },
        { key: 'receiveMode', label: '发放方式', type: 'select', options: [{ label: '主动发放', value: '自动发放' }, { label: '用户领取', value: '主动领取' }] },
        { key: 'grantTarget', label: '发放对象', type: 'select', visible: form => form.receiveMode !== '主动领取', options: [{ label: '所有用户', value: '所有用户' }, { label: '指定用户', value: '指定用户' }, { label: '未下单过的用户', value: '未下单用户' }, { label: '新注册用户', value: '新注册用户' }] },
        { key: 'specifiedUserIds', label: '指定用户ID', placeholder: '多个用户ID用英文逗号分隔', visible: form => form.receiveMode !== '主动领取' && form.grantTarget === '指定用户' },
        { key: 'thresholdAmount', label: '使用门槛', type: 'number', min: 0, precision: 2 },
        { key: 'discountAmount', label: '优惠金额', type: 'number', min: 0, precision: 2 },
        { key: 'startTime', label: '开始时间', type: 'datetime' },
        { key: 'endTime', label: '结束时间', type: 'datetime' },
        { key: 'validDays', label: '领取后有效天数', type: 'number', min: 0, placeholder: '0表示按结束时间失效' },
        { key: 'totalCount', label: '发行数量', type: 'number', min: 0, visible: form => form.receiveMode === '主动领取' },
        { key: 'status', label: '状态', type: 'switch' }
      ]
    }
  }
}
</script>
